/* eslint-disable prettier/prettier */
import { skills } from "../constants"
import BeInTouch from "../components/BeInTouch"
import SkeletonImage from "../components/SkeletonImage"
import Footer from "../components/Footer/Footer"
import { Helmet } from "react-helmet"

const About = () => {
  return (
    <>
      <Helmet>
        <title>About | Muhammed Mashady - Full Stack Developer</title>
        <meta
          name="description"
          content="Learn more about Muhammed Mashady, a software developer based in Egypt specializing in full-stack web and mobile application development."
        />
        <meta property="og:title" content="About | Muhammed Mashady" />
        <meta property="og:description" content="Learn more about Muhammed Mashady, a software developer specializing in full-stack web and mobile development." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>
      <section className="max-w-[1240px] mx-auto pt-12 px-4">
        <h1 className="text-3xl ubuntu-bold">Hey, its abusamir</h1>
        <div className="mt-5 flex flex-col gap-3 ">
          <p className="text-[22px] md:text-[24px]">
            Software Developer based in Egypt, specializing in Full web app
            building in both ui and server side, also buliding mobile
            application.
          </p>
        </div>
        <div className="flex flex-col mt-10 mb-16">
          <h3 className="text-2xl ubuntu-bold">Skills & Technologies</h3>
          <div className="flex flex-wrap gap-10 mt-6 justify-center md:justify-start">
            {skills.map((skill) => (
              <div key={skill.name}>
                <div className="rounded-xl flex flex-col justify-center items-center gap-2">
                  <div className="relative w-[7rem] h-[8rem]">
                    <SkeletonImage
                      src={skill.imageUrl}
                      alt={skill.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <span className="text-xs text-center" style={{ color: "var(--typo)" }}>
                    {skill.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <hr className="border-[#79747b]" />
        <BeInTouch />
      </section>
      <Footer />
    </>
  )
}

export default About
